module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.6882/img/video-thumb-overlay.png"